"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var bluebird = require("bluebird");
var browserfs = require("browserfs");
var nodeFsModule = require("fs");
var cat_file_1 = require("./commands/cat-file");
var hash_object_1 = require("./commands/hash-object");
var init_1 = require("./commands/init");
var log_1 = require("./commands/log");
var process_argv_1 = require("./commands/process-argv");
var version_1 = require("./commands/version");
bluebird.promisifyAll(nodeFsModule);
var TsGit = /** @class */ (function () {
    function TsGit(fileSystemType) {
        if (fileSystemType === void 0) { fileSystemType = 'FileSystem'; }
        this.fsPromise = new Promise(function (resolve, reject) {
            if (fileSystemType === 'LocalStorage') {
                browserfs.configure({ fs: 'LocalStorage', options: {} }, function (err) {
                    if (err) {
                        reject(err);
                    }
                    else {
                        var localStorageFS = browserfs.BFSRequire('fs');
                        bluebird.promisifyAll(localStorageFS);
                        resolve(localStorageFS);
                    }
                });
            }
            else if (fileSystemType === 'InMemory') {
                browserfs.configure({ fs: 'InMemory', options: {} }, function (err) {
                    if (err) {
                        reject(err);
                    }
                    else {
                        var inMemoryFS = browserfs.BFSRequire('fs');
                        bluebird.promisifyAll(inMemoryFS);
                        resolve(inMemoryFS);
                    }
                });
            }
            else if (fileSystemType === 'FileSystem') {
                resolve(nodeFsModule);
            }
            else {
                reject("Unknown file system type: \"" + fileSystemType + "\". " +
                    " Expected 'InMemory', 'LocalStorage', or 'FileSystem'");
            }
        });
    }
    // Commands
    /**
     * Equivalent to git's "init" command
     * @param cwd The current working directory
     */
    TsGit.prototype.init = function (cwd) {
        return __awaiter(this, void 0, void 0, function () {
            var fs, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.fsPromise];
                    case 1:
                        fs = _a.sent();
                        return [4 /*yield*/, init_1.initCommand(fs, cwd)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        err_1 = _a.sent();
                        return [2 /*return*/, this.getUexpectedResult(err_1)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Equivalent to git's "cat-file" command
     * @param cwd The current working directory
     * @param type The type of the object
     * @param object The name of the object to show
     */
    TsGit.prototype.catFile = function (cwd, type, object) {
        return __awaiter(this, void 0, void 0, function () {
            var fs, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.fsPromise];
                    case 1:
                        fs = _a.sent();
                        return [4 /*yield*/, cat_file_1.catFileCommand(fs, cwd, type, object)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        err_2 = _a.sent();
                        return [2 /*return*/, this.getUexpectedResult(err_2)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Equivalent to git's "hash-object" command
     * @param cwd The current working directory
     * @param filePath The path to a file
     * @param write Whether or not to actually write the object
     * to the object database
     * @param type The object type
     */
    TsGit.prototype.hashObject = function (cwd, filePath, write, type) {
        if (write === void 0) { write = false; }
        if (type === void 0) { type = 'blob'; }
        return __awaiter(this, void 0, void 0, function () {
            var fs, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.fsPromise];
                    case 1:
                        fs = _a.sent();
                        return [4 /*yield*/, hash_object_1.hashObjectCommand(fs, cwd, filePath, write, type)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        err_3 = _a.sent();
                        return [2 /*return*/, this.getUexpectedResult(err_3)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * A very simplified equivalent to git's "log" command
     * @param cwd The current working directory
     * @param commit The name of the commit to begin logging
     */
    TsGit.prototype.log = function (cwd, commit) {
        return __awaiter(this, void 0, void 0, function () {
            var fs, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.fsPromise];
                    case 1:
                        fs = _a.sent();
                        return [4 /*yield*/, log_1.logCommand(fs, cwd, commit)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        err_4 = _a.sent();
                        return [2 /*return*/, this.getUexpectedResult(err_4)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TsGit.prototype.version = function () {
        return __awaiter(this, void 0, void 0, function () {
            var err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, version_1.versionCommand()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        err_5 = _a.sent();
                        return [2 /*return*/, this.getUexpectedResult(err_5)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    TsGit.prototype.processArgv = function (argv) {
        return __awaiter(this, void 0, void 0, function () {
            var err_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, process_argv_1.processArgvCommand(this, argv)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        err_6 = _a.sent();
                        return [2 /*return*/, this.getUexpectedResult(err_6)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    TsGit.prototype.getUexpectedResult = function (err) {
        return {
            success: false,
            message: "An unexpected error occurred!\n" + err,
        };
    };
    return TsGit;
}());
exports.TsGit = TsGit;
